import React from "react";
import * as TooltipPrimitives from "@radix-ui/react-tooltip";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

interface InfoTooltipProps {
  text: React.ReactNode;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ text }) => {
  return (
    <TooltipPrimitives.Provider>
      <TooltipPrimitives.Root delayDuration={0}>
        <TooltipPrimitives.Trigger asChild>
          <InformationCircleIcon className="w-4 h-4 text-gray-400 cursor-help ml-1" />
        </TooltipPrimitives.Trigger>
        <TooltipPrimitives.Portal>
          <TooltipPrimitives.Content
            side="top"
            sideOffset={4}
            className="z-50 max-w-xs rounded-md bg-zinc-800 px-3 py-2 text-xs text-white shadow-md"
          >
            {text}
            <TooltipPrimitives.Arrow className="fill-zinc-800" />
          </TooltipPrimitives.Content>
        </TooltipPrimitives.Portal>
      </TooltipPrimitives.Root>
    </TooltipPrimitives.Provider>
  );
};

InfoTooltip.displayName = "InfoTooltip";

export { InfoTooltip };
